// export const API_BASE_URL = "https://api-c3m.veldev.com/api/";
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const AUTH_LOGIN = "/auth/login/";
export const AUTH_LOGOUT = "/auth/logout/";
export const AUTH_REFRESH = "/auth/refresh/";
export const FORGOT_PASSWORD = "/forgot-password/";
export const RESET_PASSWORD = "/reset-password/";
export const AUTH_WHOAMI = "/whoami/";

export const AUTH_VERIFY_2FA = "/auth/login/verify-2fa/";
export const AUTH_VERIFY_2FA_RESEND_OTP = "/auth/login/verify-2fa/resend-otp/";
export const AUTH_VERIFY_2FA_BACKUP_CODE = "/auth/login/verify-2fa/backup-code/";
export const TWO_FA_SETUP = "/auth/2fa/setup/";
export const TWO_FA_CONFIRM = "/auth/2fa/confirm/";
export const TWO_FA_DISABLE = "/auth/2fa/disable/";
export const TWO_FA_DISABLE_SEND_OTP = "/auth/2fa/disable/send-otp/";
export const TWO_FA_BACKUP_CODES_GENERATE = "/auth/2fa/backup-codes/generate/";
export const TWO_FA_BACKUP_CODES_DOWNLOAD = "/auth/2fa/backup-codes/download/";
export const ORG_2FA_ENFORCEMENT = (id) =>
  `/organisations/${id}/2fa-enforcement/`;

export const MASTERS_GROUP = "/masters/groups/";
export const MASTERS_CONTRACT_TYPES = "/masters/contract-types/";
export const MASTERS_DOCUMENT_TYPES = "/masters/contract-doc-types/";
export const MASTERS_CONTRACT_ROLES = "/masters/contract-role-types/";
export const MASTERS_CONTRACT_TASK_TYPES = "/masters/contract-task-types/";
export const GET_DOCUMENTS = `masters/document-download/`;
export const ORGANISATIONS = "/organisations/";
export const MASTER_ROLES = "/masters/contract-role-types/";
export const DELETE_ROLE = (roleId) =>
  `/masters/contract-role-types/${roleId}/`;
export const UPDATE_ROLE = (roleId) =>
  `/masters/contract-role-types/${roleId}/`;

export const USERS = "/users/";
export const USERS_CREATE = "/users/create/";
export const UPDATE_USER_PROFILE = "/profile/";
export const CHANGE_PASSWORD = "/change-password/";
export const USERS_UPDATE = (id) => `/users/${id}/update/`;
export const USERS_DELETE = (id) => `/users/${id}/delete/`;

export const ORGANISATIONS_CREATE = "/organisations/create/";
export const ORGANISATIONS_DELETE = (id) => `/organisations/${id}/delete/`;
export const ORGANISATIONS_UPDATE = (id) => `/organisations/${id}/update/`;

export const LIST_CONTRACTS = "/contracts/";
export const CREATE_CONTRACTS = "/contracts/create/";
export const CONTRACT_UPDATE = (id) => `/contracts/${id}/update/`;
export const CONTRACT_DELETE = (id) => `/contracts/${id}/delete/`;
export const ADD_REPOSITORY = (id) => `/contracts/${id}/documents/upload/`;
export const GET_REPOSITORY = (id) => `/contracts/${id}/documents/`;
export const GET_REPOSITORY_SOURCES = (id) =>
  `/contracts/${id}/documents/sources/`;
export const DELETE_REPOSITORY = (contractId, documentId) =>
  `/contracts/${contractId}/documents/${documentId}/delete/`;
export const CONTRACT_DETAILS = (id) => `/contracts/${id}/`;

export const GET_RESPONSIBILITY = (id) => `/contracts/${id}/responsibility`;
export const ADD_RESPONSIBILITY = (id) =>
  `/contracts/${id}/responsibility/create/`;
export const COPY_RESPONSIBILITY = (id) =>
  `/contracts/${id}/responsibility/copy/`;
export const DELETE_RESPONSIBILITY = (contractId, id) =>
  `/contracts/${contractId}/responsibility/${id}/delete/`;

export const GET_OBLIGATIONS = (id) => `/contracts/${id}/obligations/`;
export const ADD_OBLIGATION = (id) => `/contracts/${id}/obligations/create/`;
export const UPDATE_OBLIGATION = (obligationId) =>
  `/obligations/${obligationId}/update/`;
export const DELETE_OBLIGATION = (id) => `/obligations/${id}/delete/`;
export const GET_OBLIGATION_DETAILS = (obligationId) =>
  `/obligations/${obligationId}/`;
export const GET_OBLIGATION_TASKS = (obligationId) =>
  `/obligations/${obligationId}/tasks/`;
export const ADD_OBLIGATION_CLOSING_DETAILS = (obligationId) =>
  `/obligations/${obligationId}/closingdetails/`;
export const UPDATE_OBLIGATION_PRIORITY = (obligationId) =>
  `/obligations/${obligationId}/priority/`;
export const GET_SCHEDULE_TASKS = (contractId) =>
  `/contracts/${contractId}/tasks/`;
export const CREATE_SCHEDULE_TASK = (contractId) =>
  `/contracts/${contractId}/tasks/create/`;
export const GET_TASK_DETAILS = (taskId) => `/tasks/${taskId}/`;
export const UPDATE_TASK = (taskId) => `/tasks/${taskId}/update/`;
export const UPDATE_TASK_PRIORITY = (taskId) => `/tasks/${taskId}/priority/`;
export const DELETE_TASK = (taskId) => `/tasks/${taskId}/delete/`;
export const GET_TASK_UPDATES = (taskId) => `/tasks/${taskId}/updates/`;
export const CREATE_TASK_UPDATE = (taskId) => `/tasks/${taskId}/updates/`;
export const UPDATE_TASK_UPDATE = (updateId) => `/tasks/updates/${updateId}/`;
export const UPLOAD_TASK_UPDATE_DOCUMENTS = (updateId) =>
  `/tasks/updates/${updateId}/documents/upload/`;
export const DELETE_TASK_UPDATE_DOCUMENT = (documentId) =>
  `/tasks/updates/documents/${documentId}/delete/`;
export const UPLOAD_TASK_CREATE_DOCUMENTS = (taskId) =>
  `/tasks/${taskId}/documents/upload/`;
export const ADD_TASK_CLOSING_DETAILS = (taskId) =>
  `/tasks/${taskId}/closingdetails/`;

export const GET_MILESTONES = (contractId) =>
  `/contracts/${contractId}/milestones/`;
export const CREATE_MILESTONE = (contractId) =>
  `/contracts/${contractId}/milestones/create/`;
export const CREATE_MILESTONE_BULK = (contractId) =>
  `/contracts/${contractId}/milestones/bulk/`;
export const DELETE_MILESTONE = (milestoneId) =>
  `/contracts/milestones/${milestoneId}/delete/`;
export const ADD_PAYMENT_RECEIVED = (milestoneId) =>
  `/contracts/milestones/${milestoneId}/payments/create/`;

export const GET_FINANCE_PAYMENTS = (contractId) =>
  `/contracts/${contractId}/finance-payments/`;
export const CREATE_FINANCE_PAYMENT = (contractId) =>
  `/contracts/${contractId}/finance-payments/create/`;
export const GET_FINANCE_PAYMENT_DETAILS = (paymentId) =>
  `/contracts/finance-payments/${paymentId}/`;
export const UPDATE_FINANCE_PAYMENT = (paymentId) =>
  `/contracts/finance-payments/${paymentId}/update/`;
export const DELETE_FINANCE_PAYMENT = (paymentId) =>
  `/contracts/finance-payments/${paymentId}/delete/`;
export const UPLOAD_FINANCE_PAYMENT_DOCUMENT = (contractId) =>
  `/contracts/${contractId}/finance-payments/documents/upload/`;

export const CREATE_TIMELINE_EXTENSION = (obligationId) =>
  `/obligations/${obligationId}/timeline-extensions/create/`;
export const UPLOAD_TIMELINE_EXTENSION_DOCUMENT = (timelineExtensionId) =>
  `/timeline-extensions/${timelineExtensionId}/documents/upload/`;

export const GET_NEGATIVE_COVENANTS = (contractId) =>
  `/contracts/${contractId}/negative-covenants/`;
export const UPDATE_NEGATIVE_COVENANT = (covenantId) =>
  `/contracts/negative-covenants/${covenantId}/`;
export const DELETE_NEGATIVE_COVENANT = (covenantId) =>
  `/contracts/negative-covenants/${covenantId}/`;
export const UPLOAD_COVENANT_DOCUMENTS = (covenantId) =>
  `/contracts/negative-covenants/${covenantId}/documents/`;

export const CREATE_SCHEDULE_EXTENSION = (contractId) =>
  `/contracts/${contractId}/schedule-extensions/create/`;

export const UPLOAD_EXTENSION_DOCUMENT = (extensionId) =>
  `/schedule-extensions/${extensionId}/documents/upload/`;

export const GET_SCHEDULE_EXTENSION_LIST = (contractId) =>
  `contracts/${contractId}/schedule-extensions/`;

export const GET_SCHEDULE_EXTENSION = (extensionId) =>
  `schedule-extensions/${extensionId}/`;

export const RESOLVE_TASK_UPDATE_ISSUE = (updateId) =>
  `tasks/updates/${updateId}/resolve/`;

export const DASHBOARD_FLAGGED_TASKS = (contractId) =>
  `contracts/${contractId}/dashboard/flagged-tasks/`;

export const DASHBOARD_TASK_STATISTICS = (contractId) =>
  `contracts/${contractId}/dashboard/task-statistics/`;

export const DASHBOARD_OBLIGATION_STATUS_STATISTICS = (contractId) =>
  `contracts/${contractId}/dashboard/obligation-status-statistics/`;

export const DASHBOARD_OBLIGATION_TYPE_STATISTICS = (contractId) =>
  `contracts/${contractId}/dashboard/obligation-type-statistics/`;

export const GET_SUB_CONTRACTS = (contractId) =>
  `contracts/${contractId}/subcontracts/`;

export const GET_PARENT_OBLIGATIONS = (contractId) =>
  `/contracts/${contractId}/obligations/copy-options/`;

export const COPY_OBLIGATIONS = (contract_id) =>
  `contracts/${contract_id}/obligations/copy/`;

export const GET_COMMUNICATION = (taskId) => `tasks/${taskId}/communications/`;

export const CREATE_COMMUNICATION = (taskId) =>
  `tasks/${taskId}/communications/`;

export const UPDATE_COMMUNICATION = (comId) => `tasks/communications/${comId}/`;

export const UPLOAD_COMMUNICATION_DOCUMENT = (comId) =>
  `tasks/communications/${comId}/documents/upload/`;

export const DELETE_COMMUNICATION_DOCUMENT = (documentId) =>
  `/tasks/communications/documents/${documentId}/delete/`;

export const GET_PROJECT_TIMELINE = (contractId) =>
  `/contracts/${contractId}/project-timeline/`;
export const PROJECT_TIMELINE_ITEM = (timelineId) =>
  `/contracts/project-timeline/${timelineId}/`;

export const GET_SUSPENSION_EVENTS = (id) =>
  `contracts/${id}/suspension-events/`;

export const DELETE_SUSPENSION_EVENT = (eventId) =>
  `/contracts/suspension-events/${eventId}/`;

export const CREATE_SUSPENSION_EVENT = (contractId) =>
  `/contracts/${contractId}/suspension-events/`;

export const UPDATE_SUSPENSION_EVENT = (id) =>
  `/contracts/suspension-events/${id}/`;

export const UPLOAD_SUSPENSION_EVENT_DOCUMENT = (eventId) =>
  `/contracts/suspension-events/${eventId}/documents/`;

export const GET_SUSPENSION_DETAILS = (eventId) =>
  `/contracts/suspension-events/${eventId}/`;

export const GET_EVENT_UPDATES = (eventId) =>
  `/contracts/suspension-events/${eventId}/updates/`;

export const CREATE_EVENT_UPDATE = (eventId) =>
  `/contracts/suspension-events/${eventId}/updates/`;

export const UPDATE_EVENT_UPDATE = (updateId) =>
  `/contracts/suspension-events/updates/${updateId}/`;

export const DELETE_EVENT_UPDATE_DOCUMENT = (documentId) =>
  `/contracts/suspension-events/updates/documents/${documentId}/delete/`;

export const UPLOAD_EVENT_UPDATE_DOCUMENTS = (updateId) =>
  `/contracts/suspension-events/updates/${updateId}/documents/`;

export const RESOLVE_SUSPENSION_ISSUE = (updateId) =>
  `/contracts/suspension-events/updates/${updateId}/resolve/`;

export const DELETE_SUSPENSION_EVENT_DOCUMENT = (documentId) =>
  `/contracts/suspension-events/documents/${documentId}/delete/`;

export const LIST_CONTRACT_PERMISSION = (id) => `/contracts/${id}/permissions`;

export const GET_TASK_SCHEDULE_EXTENSIONS = (taskId) =>
  `/tasks/${taskId}/schedule-extensions/`;
export const CREATE_TASK_SCHEDULE_EXTENSION = (taskId) =>
  `/tasks/${taskId}/schedule-extensions/create/`;
export const UPDATE_TASK_SCHEDULE_EXTENSION = (extensionId) =>
  `/task-schedule-extensions/${extensionId}/`;
export const DELETE_TASK_SCHEDULE_EXTENSION = (extensionId) =>
  `/task-schedule-extensions/${extensionId}/`;
export const APPROVE_TASK_SCHEDULE_EXTENSION = (extensionId) =>
  `/task-schedule-extensions/${extensionId}/approve/`;
export const UPLOAD_TASK_SCHEDULE_EXTENSION_DOCUMENT = (extensionId) =>
  `/task-schedule-extensions/${extensionId}/documents/upload/`;

export const GET_REPORTING_REMINDERS = (contractId) =>
  `/contracts/${contractId}/reporting-reminders/`;

export const CREATE_REPORTING_REMINDER = (contractId) =>
  `/contracts/${contractId}/reporting-reminders/`;

export const UPDATE_REPORTING_REMINDER = (reminderId) =>
  `/contracts/reporting-reminders/${reminderId}/`;

export const DELETE_REPORTING_REMINDER = (reminderId) =>
  `/contracts/reporting-reminders/${reminderId}/`;

export const GET_REPORTING_REMINDER_DETAILS = (reminderId) =>
  `/contracts/reporting-reminders/${reminderId}/`;

export const UPDATE_REMINDER_UPDATE = (updateId) =>
  `/contracts/reporting-reminders/updates/${updateId}/`;

export const UPLOAD_REMINDER_UPDATE_DOCUMENT = (updateId) =>
  `/contracts/reporting-reminders/updates/${updateId}/documents/`;

export const DELETE_REMINDER_UPDATE_DOCUMENT = (documentId) =>
  `/contracts/reporting-reminders/updates/documents/${documentId}/delete/`;

export const GET_CHATBOT_CONVERSATIONS = "/chat/get_conversations";
export const GET_CHATBOT_HISTORY = "/chat/get_history";
export const DELETE_CHATBOT_CONVERSATIONS = "/chat/delete_conversations";

export const GET_DEVIATIONS = (contractId) =>
  `/contracts/${contractId}/deviations/`;
export const CREATE_DEVIATION = (contractId) =>
  `/contracts/${contractId}/deviations/`;

export const GET_DEVIATION_DETAILS = (contractId, deviationId) =>
  `/contracts/${contractId}/deviations/${deviationId}`;
export const UPLOAD_DEVIATION_DOCUMENT = (contractId) =>
  `/contracts/${contractId}/deviations/documents/upload/`;
export const DELETE_DEVIATION_DOCUMENT = (contractId, documentId) =>
  `/contracts/${contractId}/deviations/documents/${documentId}/delete/`;

export const GET_DEVIATION = (contractId, deviationId) =>
  `/contracts/${contractId}/deviations/${deviationId}/`;

export const UPDATE_DEVIATION = (contractId, deviationId) =>
  `/contracts/${contractId}/deviations/${deviationId}/`;

export const DELETE_DEVIATION = (contractId, deviationId) =>
  `/contracts/${contractId}/deviations/${deviationId}/`;

export const GET_DEVIATION_FILTER_OPTIONS = `/contracts/deviation-types/`;

export const FLOWCHART_EXPORT = (contractId) =>
  `/contracts/${contractId}/flowchart/export/`;

export const FLOWCHART_GET = (contractId) =>
  `/contracts/${contractId}/flowchart/`;

export const GET_NOTIFICATIONS = `/contracts/notifications/`;
export const READ_NOTIFICATION = (id) => `/contracts/notifications/${id}/read/`;
export const READ_ALL_NOTIFICATIONS = `/contracts/notifications/read-all/`;
export const BOOKMARK_NOTIFICATION = (id) =>
  `/contracts/notifications/${id}/bookmark/`;
export const UNBOOKMARK_NOTIFICATION = (id) =>
  `/contracts/notifications/${id}/unbookmark/`;
